import { createRouter, createWebHistory } from 'vue-router'
import UploadPage from '../views/UploadPage.vue'
import PasswordPage from '../views/PasswordPage.vue'
import ClosedPage from '../views/ClosedPage.vue'
import NotFoundPage from '@/views/NotFoundPage.vue'
import { SHARING_STATE, AUTH_STATUS } from '@/utils/constant'
import { reloadWithoutRouting } from '@/utils/appinfo/index'
import { insertDriveMSTextsScript } from '@/utils/appinfo/index'
import { computed } from 'vue'
import store from '@/store'

const homeRedirect = () => {
  const { sharingState } = store.state

  switch (sharingState) {
    case SHARING_STATE.FILE_REQUEST_PASSWORD:
      return '/password'

    case SHARING_STATE.FILE_REQUEST_CLOSED:
      return '/closed'

    case SHARING_STATE.FILE_REQEUST_EXPIRED:
    case SHARING_STATE.FILE_REQUEST_ERROR:
      return '/notfound'

    case SHARING_STATE.FILE_REQUEST_OK:
      return '/upload'

    default:
      return '/notfound'
  }
}

const routes = [
  {
    path: '/',
    redirect: homeRedirect,
  },
  {
    path: '/upload',
    name: 'Home',
    meta: {
      requireLogin: true,
      allowSharingToken: true,
    },
    component: UploadPage,
    beforeEnter: async(to, from, next) => {
      await insertDriveMSTextsScript()
      await store.dispatch('initAppData')
      next()
    }
  },
  {
    path: '/password',
    name: 'Password',
    component: PasswordPage,
    beforeEnter: async(to, from, next) => {
      const sharingState = computed(() => store.state.sharingState)
      if (sharingState.value === SHARING_STATE.FILE_REQUEST_OK) {
        return next('/upload')
      }

      if (sharingState.value === SHARING_STATE.FILE_REQUEST_CLOSED) {
        return next('/closed')
      }

      if (sharingState.value === SHARING_STATE.FILE_REQEUST_EXPIRED || sharingState.value === SHARING_STATE.FILE_REQUEST_ERROR) {
        return next('/notfound')
      }

      await insertDriveMSTextsScript()
      next()
    }
  },
  {
    path: '/closed',
    name: 'Closed',
    component: ClosedPage,
    beforeEnter: async(to, from, next) => {
      if (sharingState.value !== SHARING_STATE.FILE_REQUEST_CLOSED) {
        return next('/')
      }

      await insertDriveMSTextsScript()
      next()
    }
  },
  {
    path: '/notfound',
    name: 'NotFound',
    component: NotFoundPage,
    beforeEnter: async(to, from, next) => {
      if (sharingState.value !== SHARING_STATE.FILE_REQEUST_EXPIRED && sharingState.value !== SHARING_STATE.FILE_REQUEST_ERROR) {
        return next('/')
      }

      await insertDriveMSTextsScript()
      next()
    }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: homeRedirect,
  }
]

const router = createRouter({
  history: createWebHistory(window.location.pathname + '#'),
  routes
})

const sharingState = computed(() => store.state.sharingState)
const authStatus = computed(() => store.getters.getAuthStatus)

router.beforeEach((to, from, next) => {
  if (to.meta.requireLogin && sharingState.value !== SHARING_STATE.FILE_REQUEST_OK) {
    if (authStatus.value !== AUTH_STATUS.DONE) {
      return next('/password')
    }
    reloadWithoutRouting()
  }

  next()
})

export default router;
